import React from "react";
import {
  FaThumbsUp,
  FaThumbsDown,
  FaCheckCircle,
  FaShareAlt,
} from "react-icons/fa";

export default function Card({
  item,
  vote,
  isRead,
  onVote,
  onReadMore,
  onShare,
  classes,
}) {
  const summaryText = (item.summary || "")
  .replace(/<img[^>]*>/gi, "")
  .replace(/<\/?p[^>]*>/gi, "")
  .replace(/<a[^>]+><\/a>/gi, "")
  .trim()
  .split(/\s+/)
  .slice(0, 10)
  .join(" ") + " ...";


  const imageUrl = item.enclosure[1]?.href || item.enclosure[0]?.href;

  return (
    <div
      className={classes.card}
      data-id={item.id}
      style={{ scrollMarginTop: "10px" }}
    >
      {imageUrl && <img className={classes.cardImage} src={imageUrl} alt="" />}
      <div className={classes.cardContent}>
        <h2 className={classes.cardTitle}>
          {(item.title || "").replace(/&pound;/gi, "$")}

        </h2>
        <div className={classes.cardMeta}>
          {new Date(item.publishedAt).toLocaleString()}
          {item.author ? ` • ${item.author}` : ""}
        </div>

        <div className={classes.cardSummary}>
          <div className="summary-text">{summaryText}</div>
               <a
            className={classes.cardLink}
            href={item.canonical?.[0]?.href || "#"}
            target="_blank"
            rel="noopener noreferrer"
          >
            Read more →
          </a>
          <div className={classes.summaryVotes}>
            <div className={classes.readSection}>
              {isRead && (
                <>
                  <FaCheckCircle
                    className={`${classes.readIcon} ${classes.read}`}
                  />
                  <span className={classes.voteLabel}>Recently Read</span>
                </>
              )}
            </div>

            <div className={classes.voteSectionBox}>
              <div className={classes.voteItem}>
                <button
                  className={`${classes.voteBtn} ${classes.vote} ${
                    vote === 1 ? classes.voted : ""
                  }`}
                  onClick={() => onVote(1)}
                >
                  <FaThumbsUp />
                </button>
                <span className={classes.voteLabel}>Like</span>
              </div>

              <div className={classes.voteItem}>
                <button
                  className={`${classes.voteBtn} ${
                    vote === -1 ? `${classes.voted}` : ""
                  }`}
                  onClick={() => onVote(-1)}
                >
                  <FaThumbsDown />
                </button>
                <span className={classes.voteLabel}>Dislike</span>
              </div>

              {/* <div className={classes.voteItem}>
                <button
                  className={classes.voteBtn}
                  onClick={() => onShare(item.id)}
                  title="Share this news"
                >
                  <FaShareAlt />
                </button>
                <span className={classes.voteLabel}>Share</span>
              </div> */}
              <div className={classes.voteItem} onClick={() => onShare(item.id)} style={{ cursor: "pointer" }}>
  <button
    className={classes.voteBtn}
    title="Share this news"
    style={{ pointerEvents: "none" }} // prevent double event
  >
    <FaShareAlt />
  </button>
  <span className={classes.voteLabel}>Share</span>
</div>

            </div>
          </div>

       
        </div>
      </div>
    </div>
  );
}
